import React from "react";

const LazyBoardRedirect = React.lazy(() =>
  import("./BoardRedirect").then((module) => ({ default: module.BoardRedirect }))
);

export default LazyBoardRedirect;
